import { classes } from 'html-classes';

import { company } from '~/company/Company';

import styles from './Badge.module.scss';

type BadgeProps = {
  className?: string;
  size?: 'xxs' | 'xs' | 's' | 'm';
  children: React.ReactNode;
  theme:
    | 'primary'
    | 'secondary'
    | 'gray'
    | 'express'
    | 'canceled'
    | 'pending'
    | 'black';
  style?: React.CSSProperties;
};
const Badge = ({
  className,
  size = 's',
  theme = 'primary',
  children,
  style,
}: BadgeProps) => {
  return (
    <div
      data-company={company.name}
      className={classes([
        styles.badgeContainer,
        className,
        styles[`size_${size}`],
        styles[`theme_${theme}`],
      ])}
      style={style}
    >
      {children}
    </div>
  );
};

export default Badge;
